// 基础配置信息
export const basicDefault = {
  left: 0,
  top: 0,
  width: 300,
  height: 300
}
export const basicConfig = [
  {
    info: {
      title: '基础配置',
      icon: 'icon-setting'
    },
    fields: [
      { title: '横向位移', name: 'left', description: '横向位移', type: 'number' },
      { title: '纵向位移', name: 'top', description: '纵向位移', type: 'number' },
      { title: '组件宽度', name: 'width', description: '组件宽度', type: 'number' },
      { title: '组件高度', name: 'height', description: '组件高度', type: 'number' }
    ]
  }
]
